<template>
  <router-link
    v-if="link && link.internal"
    :to="link.to"
    :aria-label="link.aria_label || undefined"
  >
    <slot>{{ link.label }}</slot>
  </router-link>
  <a
    v-else-if="link"
    :href="link.href"
    :target="link.target || undefined"
    :rel="link.rel || undefined"
    :aria-label="link.aria_label || undefined"
  >
    <slot>{{ link.label }}</slot>
  </a>
</template>

<script>
  /**
   * CMS link: renders `<router-link>` for internal destinations (SPA routes) or
   * `<a href>` for external links, based on `link.internal` computed by
   * `resolve_link` (see content-utilities.js). Content is passed via slot (the link
   * label by default). `class`/`style` from the caller are automatically applied
   * to the rendered element.
   */
  export default {
    name: 'content-link',

    props: {
      link: {
        type: Object,
        default: null,
      },
    },
  };
</script>
